
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/_efro-oost/nieuws/[slug]",
      function () {
        return require("private-next-pages/_sites/_efro-oost/nieuws/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/_efro-oost/nieuws/[slug]"])
      });
    }
  